import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import ModalCard, {
    ModalRow,
    ModalTitle,
} from "../../components/modal/ModalCard";
import MacAddressImage from "../../assets/images/garbageCan/mac.png";
import macAddressUtils from "../../utils/macAddressUtils";
import { ChangeEvent } from "react";

const Container = styled("div")({
    marginTop: 10,
    height: 350,
    overflow: "auto",
    padding: 10,
});

interface SesnorConfigStepProps {
    macAddress: string;
    setMacAddress: (value: string) => void;
}
const PATTERN_ADDRESS_MAC = /[^A-Fa-f0-9]/g;
const LENGTH_ADDRESS_MAC = 17;
const MAXIMUM_CHARACTERS = 12;
const SensorConfigStep = ({
    macAddress,
    setMacAddress,
}: SesnorConfigStepProps) => {
    const onChangeMacAddress = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const input = (event.target.value || "").toUpperCase();

        const cleanedInput = input
            .replace(PATTERN_ADDRESS_MAC, "")
            .substring(0, MAXIMUM_CHARACTERS);
        const formattedMacAddress = (cleanedInput.match(/.{1,2}/g) || [])
            .join(":")
            .substring(0, LENGTH_ADDRESS_MAC);

        setMacAddress(formattedMacAddress || "");
    };

    return (
        <Container>
            <ModalCard.Main isDivider={false}>
                <ModalRow sx={{ textAlign: "left" }}>
                    <ModalTitle>Mac Address (*)</ModalTitle>

                    <TextField
                        error={
                            macAddress.length > 0 &&
                            !macAddressUtils.isMacAdrress(macAddress)
                        }
                        placeholder="FF:FF:FF:FF:FF"
                        style={{ textAlign: "left", width: "80%" }}
                        value={macAddress}
                        onChange={(e) => onChangeMacAddress(e)}
                        margin="normal"
                        variant="outlined"
                    />
                </ModalRow>
                <ModalRow>
                    <ModalTitle></ModalTitle>
                    <img width={"35%"} height={"35%"} src={MacAddressImage} />
                </ModalRow>
            </ModalCard.Main>
        </Container>
    );
};

export default SensorConfigStep;
